



// export const Customstyles = {
//   degreeToSymbol: {
//     name: "Convert 'degree' to °",
//     description: "10 degree → 10°C",
//     markerClass: "highlight", // CSS class for highlight
//     execute: function(editor, anchorList) {
//       const content = editor.getContent({ format: "html" });
//       const pattern = /\b(deg|degree|degrees)\b/gi;

//       const newContent = content.replace(pattern, (match) => {
//         const suggestion = match.toLowerCase() === 'deg' ? '°' : `${match}°C`;
//         const anchorId = `anchor-${Math.random().toString(36).substr(2, 9)}`;

//         // Add to anchor list for SuggestionsData
//         anchorList.push({
//           id: anchorId,
//           styleId: 'degreeToSymbol',
//           originalText: match,
//           suggestedText: suggestion
//         });

//         // <<< THIS LINE >>> highlight match in editor
//         return `<span class="${this.markerClass}" data-anchor-id="${anchorId}">${match}</span>`;
//       });

//       editor.setContent(newContent);
//     }
//   },

//   correctIE_EGPeriods: {
//     name: "Correct i.e. and e.g. punctuation",
//     description: "Add missing periods after i.e and e.g",
//     markerClass: "highlight",
//     execute: function(editor, anchorList) {
//       const content = editor.getContent({ format: "html" });
//       const pattern = /\b(i\.e|e\.g)(?!\.)\b/gi;

//       const newContent = content.replace(pattern, (match) => {
//         const suggestion = `${match}.`;
//         const anchorId = `anchor-${Math.random().toString(36).substr(2, 9)}`;
//         anchorList.push({ id: anchorId, styleId: 'correctIE_EGPeriods', originalText: match, suggestedText: suggestion });
//         return `<span class="${this.markerClass}" data-anchor-id="${anchorId}">${match}</span>`;
//       });

//       editor.setContent(newContent);
//     }
//   }
// };


// Customstyles.js
// Customstyles.js
// Customstyles.js
// Customstyles.js

function replaceMatch(editor, match, replacement) { 

  const doc = editor.getDoc();

  const range = doc.createRange();
  range.setStart(match.node, match.start);
  range.setEnd(match.node, match.end);

  editor.selection.setRng(range);

  editor.insertContent(replacement);
}

function showSuggestionPopup(editor, match, rect, mark) {

  const oldPopup = document.querySelector(".suggestion-popup");
  if (oldPopup) oldPopup.remove();

  const popup = document.createElement("div");
  popup.className = "suggestion-popup";

  Object.assign(popup.style, {
    position: "absolute",
    top: rect.bottom + window.scrollY + 8 + "px",
    left: rect.left + window.scrollX + "px",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "8px",
    padding: "10px",
    zIndex: "99999",
    boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
    fontSize: "14px"
  });

  popup.innerHTML = `
     <div style="position: relative; padding: 10px; min-width: 220px;">
     <span class="popup-close text-end" style="cursor:pointer; font-weight:bold; position: absolute; top: -8px; right: 0; cursor: pointer;">&times;</span>
    <div style="margin-bottom: 12px; color: #4a5568;">
      <strong>${match.name}</strong>     
    </div>
     <div style="display: flex; flex-direction: column; gap: 8px; margin-bottom: 12px;">
      <div style="display: flex; align-items: center; padding: 8px; background: #fef5f5; border-radius: 4px; border: 1px solid #fed7d7;">
        <span style="color: #c53030; margin-right: 8px;">${match.text}</span>
      </div>

      <div style="display: flex; align-items: center; padding: 8px; background: #f0fff4; border-radius: 4px; border: 1px solid #c6f6d5;">
        <span style="color: #22543d; margin-right: 8px;">${match.suggested}</span>
      </div>
    </div>
   
    <div class="flex justify-end">
    <button class="suggestion-accept"
      style="background:#22c55e;color:#fff;border:none;padding:5px 10px;border-radius:4px;margin-right:6px;">
      Accept
    </button>

    <button class="suggestion-ignore"
      style="background:#eee;border:none;padding:5px 10px;border-radius:4px;">
      Ignore
    </button>
    </div>
    </div>
  `;

  document.body.appendChild(popup);

 

  popup.querySelector(".popup-close").onclick = () => {
    popup.remove();
  };

  popup.querySelector(".suggestion-accept").onclick = () => {
    replaceMatch(editor, match, match.suggested);
    if (hoverTimer) {
      clearTimeout(hoverTimer);
      hoverTimer = null;
    }
    match.processed = true;
    if (mark) {
      mark.remove();
    }
    popup.remove();
    const layer = editor.getBody().querySelector(".suggestion-highlight-layer");
    if (layer) {
      layer.innerHTML = "";
    }
  };

  popup.querySelector(".suggestion-ignore").onclick = () => {

  const layer = editor.getBody().querySelector(".suggestion-highlight-layer");

  if (layer) {
    const marks = layer.querySelectorAll(`[data-uid="${match.uid}"]`);
    marks.forEach(m => m.remove()); //only this highlight remove
  }

  match.processed = true;

  popup.remove();
};
}

let hoverTimer = null;

function renderOverlayHighlights(editor, matches, cssClass, clearLayer = false, skipUids = new Set()) {
  const body = editor.getBody();
  const doc = editor.getDoc();

  if (!body || !doc) return;

  if (getComputedStyle(body).position === "static") {
    body.style.position = "relative";
  }

  let layer = body.querySelector(".suggestion-highlight-layer");

  if (!layer) {
    layer = doc.createElement("div");
    layer.className = "suggestion-highlight-layer";

    Object.assign(layer.style, {
      position: "absolute",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      pointerEvents: "none",
      zIndex: "9999"
    });

    body.appendChild(layer);
    console.log("Layer created:", editor.getBody().querySelector(".suggestion-highlight-layer"));
  }

  if (clearLayer) {
    layer.innerHTML = "";
  }

  const bodyRect = body.getBoundingClientRect();

  matches.forEach((match) => {
    if (skipUids.has(match.uid)) return; //Skip rejected matches
    try {
      const range = doc.createRange();
      range.setStart(match.node, match.start);
      range.setEnd(match.node, match.end);

      const rects = range.getClientRects().length
        ? Array.from(range.getClientRects())
        : [range.getBoundingClientRect()];

      console.log(rects, "rects")

      rects.forEach((rect) => {
        const mark = doc.createElement("div");

        mark.setAttribute("data-uid", match.uid);

        const left = rect.left - bodyRect.left + body.scrollLeft;
        const top = rect.top - bodyRect.top + body.scrollTop;

        Object.assign(mark.style, {
          position: "absolute",
          left: left + "px",
          top: top + "px",
          width: rect.width + "px",
          height: rect.height + "px",
          background:
            cssClass === "highlight-degree"
              ? "rgba(255,200,0,0.35)"
              : "rgba(64,150,255,0.25)",
          borderBottom:
            cssClass === "highlight-degree"
              ? "2px solid orange"
              : "2px solid #4096ff",
          pointerEvents: "auto",  
          cursor: "pointer",
          zIndex: "10000"
        });

        mark.addEventListener("mouseenter", (e) => {
          if (match.processed) return;
          e.stopPropagation();
          // console.log("highlight clicked");
          // alert("highlight clicked");
          hoverTimer = setTimeout(() => {

            if (!match.processed) {
              showSuggestionPopup(editor, match, rect, mark);
            }

          }, 1000);

        });

        mark.addEventListener("mouseleave", () => {

          if (hoverTimer) {
            clearTimeout(hoverTimer);
            hoverTimer = null;
          }

        });

        layer.appendChild(mark);
      });
    } catch (e) {
      console.warn("Highlight render error", e);
    }
  });
}

export const Customstyles = {

  degreeToSymbol: {
    id: "degreeToSymbol",
    name: "Convert 'degree' to °",
    description: "Identifies occurrences of 'deg', 'degree', or 'degrees' and suggests replacing them with the degree symbol (°) for concise scientific notation.",
    beforeImage: "/images/degree-before.png",
    afterImage: "/images/degree-after.png",
    markerClass: "highlight-degree",
    pattern: /\b(deg|degree|degrees)\b/gi,
    execute: function (editor, skipUids = new Set()) {
      if (!editor) return [];

      const matches = [];
      const body = editor.getBody();
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        let match;
        this.pattern.lastIndex = 0;

        while ((match = this.pattern.exec(text)) !== null) {
          const uid = `${node}-${match.index}-${match.index + match[0].length}`;
          if (skipUids.has(uid)) continue;
          matches.push({
            text: match[0],
            suggested: match[0].replace(/\b(deg|degree|degrees)\b/gi, "°"),
            node: node,
            start: match.index,
            end: match.index + match[0].length,
            processed: false,
            name: this.name,
            uid,
          });
        }
      }

      console.log(matches, "matches")

      if (matches.length === 0) return matches;

      renderOverlayHighlights(editor, matches, this.markerClass, true,skipUids);
      return matches;
    }
  },

  correctIE_EGCommas: {
    id: "correctIE_EGCommas",
    name: "Add comma after i.e. and e.g.",
    description: "Detects occurrences of 'i.e.' and 'e.g.' that are not followed by a comma and suggests adding a comma for correct punctuation.",
    beforeImage: "/images/i.e-before.png",
    afterImage: "/images/i.e-after.png",
    markerClass: "highlight-punctuation",
    pattern: /\b(i\.e\.|e\.g\.)(?!,)/gi,
    execute: function (editor,skipUids = new Set()) {
      if (!editor) return [];

      const matches = [];
      const body = editor.getBody();
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false);

      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue;
        let match;
        this.pattern.lastIndex = 0;

        while ((match = this.pattern.exec(text)) !== null) {
          const uid = `${node}-${match.index}-${match.index + match[0].length}`;
          if (skipUids.has(uid)) continue;
          matches.push({
            text: match[0],
            suggested: match[0] + ",",
            node: node,
            start: match.index,
            end: match.index + match[0].length,
            processed: false,
            name: this.name,
            uid,
          });
        }
      }

      if (matches.length === 0) return matches;

      renderOverlayHighlights(editor, matches, this.markerClass, false,skipUids);
      return matches;
    }
  }

};;



